import React from 'react';
import { isToday } from '../../lib/utils';
import { BookingDate } from '../../types';

interface DateCardProps {
  date: BookingDate;
  isSelected: boolean;
  onClick: (date: BookingDate) => void;
}

export const DateCard: React.FC<DateCardProps> = ({ date, isSelected, onClick }) => {
  const dateObj = new Date(date.date);
  const isTodayDate = isToday(date.date);
  
  return (
    <div 
      className={`cursor-pointer transition-all duration-200 rounded-lg border-2 p-2 sm:p-3 text-center shadow-sm hover:shadow-md relative ${
        isSelected 
          ? 'border-primary bg-primary text-white shadow-md' 
          : 'border-gray-200 hover:border-primary hover:bg-primary/5'
      } ${!date.is_active ? 'opacity-50 cursor-not-allowed border-gray-100' : ''}`}
      onClick={() => date.is_active && onClick(date)}
    >
      {isTodayDate && !isSelected && (
        <div className="absolute -top-1 -right-1 w-2 h-2 sm:w-3 sm:h-3 bg-primary rounded-full border-2 border-white"></div>
      )}
      <div className={`text-xs sm:text-xs font-medium ${isSelected ? 'text-white/80' : 'text-gray-500'}`}>
        {dateObj.toLocaleDateString('en-US', { weekday: 'short' })}
      </div>
      <div className={`text-sm sm:text-lg font-bold mt-1 ${isSelected ? 'text-white' : isTodayDate ? 'text-primary' : 'text-gray-900'}`}>
        {dateObj.getDate()}
      </div>
      <div className={`text-xs sm:text-xs mt-1 ${isSelected ? 'text-white/80' : 'text-gray-500'}`}>
        {dateObj.toLocaleDateString('en-US', { month: 'short' })}
      </div>
    </div>
  );
};
